import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Switch, TextField, useMediaQuery, useTheme
} from "@material-ui/core";

import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { BookingFormType } from "../../../store/booking/forms";
import { changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator, localize } from "../../../../../common/libs";
import { SnackbarType } from "../../../../../stores/common";
import { useTranslation} from "react-i18next";
import {MenuBookingCategory} from "../../../../../services/menu/models";
import LocalizedInput from "../../../../../common/components/translation/LocalizedInput";



const EditMenuBookingCategoryForm = () => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const [name, setName] = useState("");
    const [validationNameErr, setValidationNameErr] = useState(false);
    const [sortOrder, setSortOrder] = useState(0);
    const [isInStopList, setIsInStopList] = useState(false);

    const { bookingStore, generalStore } = useStores();
    const { forms } = bookingStore;
    const { open, current } = forms.forms[BookingFormType.createBookingCategory];
    const { t} = useTranslation(["general", "menu", "booking"]);


    useEffect(() => {

        let name = "";
        let sortOrder = 0;
        let isInStopList = false;
        if (current) {
            name = localize(current.data.name);
            sortOrder = current.data.sortOrder;
            isInStopList = current.data.isInStopList;
        }
        setIsInStopList(isInStopList);
        setName(name);
        setSortOrder(sortOrder);
    }, [current]);


    const closeForm = () => {
        forms.closeForm(BookingFormType.createBookingCategory)
    };

    const setNameWrapper = (inputValue: string) => {
        if (inputValue !== "") {
            setName(inputValue);
            setValidationNameErr(false);
        } else {
            setValidationNameErr(true)
        }
    }
    const getHelperName = () => {
        let res = t("menu:nameErr");
        if (validationNameErr) return res;
    }



    const handleSubmit = async () => {
        if (current) {
            await bookingStore.updateCategory(current.id, {
                name: current.data.name,
                sortOrder,
                isInStopList,
            });
            generalStore.showSnackbar({
                title: t("menu:menuEditor.categoryUpdatedSuccessfully"),
                type: SnackbarType.success
            })
            closeForm();
        } else {
            if (name === "") {
                setValidationNameErr(true);
                const params: ({ type: SnackbarType, title: string, description?: string }) = {
                    title: t("menu:categoryNotCreated"),
                    description: t("menu:fulfillName"),
                    type: SnackbarType.error
                };
                generalStore.showSnackbar(params);
            } else {
                await bookingStore.createCategory({
                    name, sortOrder,
                    isInStopList,
                });
                generalStore.showSnackbar({
                    title: t("menu:menuEditor.categorySuccessfullyCreated"),
                    type: SnackbarType.success
                })
                closeForm();
            }
        }
    };


    const openDeleteForm = (current?: MenuBookingCategory) => {
        bookingStore.forms.showPopupForm(BookingFormType.deleteBookingCategory, current);
    }


    let title = "";
    if (current) {
        title = t("general:editing");
    } else {
        title = t("menu:menuEditor.createCategory");
    }

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                {
                    (current && current.data && current.data.name) &&
                    <LocalizedInput
                        label = {t("general:name")}
                        value={current.data.name}
                        setNewValue ={bookingStore.setCategoryName.bind(bookingStore)}
                    />
                }
                {!current &&
                    <FormControl fullWidth margin={"normal"}>
                        <TextField
                            label={t("general:name")}
                            helperText={getHelperName()}
                            error={validationNameErr}
                            fullWidth={true}
                            value={name || ""}
                            onChange={changeEventHandlerDecorator(setNameWrapper)}
                        >
                        </TextField>
                    </FormControl>
                }
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isInStopList}
                                onChange={changeCheckboxEventHandlerDecorator(setIsInStopList)}
                                value={!isInStopList}
                            />
                        }
                        label={t("menu:menuEditor.removeCategoryToStopList")}
                    />
                </FormControl>

            </DialogContent>


            <DialogActions>
                {current && <Button
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openDeleteForm(current);
                    }}
                    style={{marginRight: 'auto'}}
                >
                    {t("general:delete")}
                </Button>}
                <Button onClick={closeForm} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(EditMenuBookingCategoryForm);
